import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('benefits_sets_export', '/benefits_sets_exports', 'export')
const actions = generator.generate()

export default actions
